/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function CaretLeft(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g>
                    <g
                        fill={iconColor || '#000'}
                        id='svg_5'
                        stroke='null'
                    >
                        <path
                            d='m22.025395,3.588574q0,0.260183 -0.348257,0.460324l-13.68649,7.865542l13.68649,7.865542q0.348257,0.200141 0.348257,0.460324t-0.348257,0.460324l-1.741284,1.000705q-0.348257,0.200141 -0.80099,0.200141t-0.80099,-0.200141l-16.228764,-9.326571q-0.348257,-0.200141 -0.348257,-0.460324t0.348257,-0.460324l16.228764,-9.326571q0.348257,-0.200141 0.80099,-0.200141t0.80099,0.200141l1.741284,1.000705q0.348257,0.200141 0.348257,0.460324z'
                            id='svg_4'
                            stroke='null'
                        />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}